import { Fragment, useContext } from "react";
import { UtilityContext } from "../../context/util-context";
import { format } from "date-fns";
import { truncate } from "../../util/format-text";
import { isoDateToString } from "../../util/format-date";

export default function PaymentCard({ payment }) {
  const { navigate } = useContext(UtilityContext);

  const borderColor =
    payment.status === "succeeded"
      ? "border-green-500"
      : payment.status === "delinquent"
      ? "border-red-500"
      : new Date(payment.dueDate) < new Date()
      ? "border-orange-500"
      : "border-yellow-500";

  return (
    <Fragment>
      <div
        className={`${borderColor} lg:hidden grid gap-4 pill`}
        onClick={(e) => navigate(`/payments/info?id=${payment.id}`, e)}
      >
        <div className="grid w-full grid-cols-4 gap-2 justify-items-center">
          <p className="text-stone-400">
            {isoDateToString(payment.dateCreated, "MM/dd/yyyy")}
          </p>
          <p className="col-span-2 truncate text-stone-200">
            {payment.customer.firstName} {payment.customer.lastName}
          </p>
          <p className="font-semibold text-white">
            ${payment.amount.toFixed(2)}
          </p>
        </div>
        <p className="text-center text-stone-400">{payment.description}</p>
      </div>
      <div
        className={`${borderColor} hidden pill lg:grid grid-cols-8 text-sm text-stone-200`}
        onClick={(e) => navigate(`/payments/info?id=${payment.id}`, e)}
      >
        <p className="text-stone-400">
          {isoDateToString(payment.dateCreated, "MM/dd/yyyy")}
        </p>
        <p className="text-white">
          {truncate(
            `${payment.customer.firstName} ${payment.customer.lastName}`
          )}
        </p>
        <p className="col-span-3 text-left">
          {truncate(payment.description, 70)}
        </p>
        <p>{isoDateToString(payment.dueDate, "MM/dd/yyyy")}</p>
        <p>{isoDateToString(payment.datePaid, "MM/dd/yyyy")}</p>
        <p className="font-semibold text-white">${payment.amount.toFixed(2)}</p>
      </div>
    </Fragment>
  );
}
